// To use Inter font in Vite/React, add this to your index.css or App.css:
// @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700&display=swap');

// Then use this className in your components:
export const geist = "font-[Inter], sans-serif";

